import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class UVTTipoSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: '',
			pk: null,
			options: [
				{ pk: 0, label: 'UVT' },
				{ pk: 1, label: 'OTT' },
			]
		};
	}

	static propTypes = {
		label: PropTypes.string,
		onChange: PropTypes.func,
		value: PropTypes.any,
		disabled: PropTypes.bool,
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.value != nextProps.value) {
			this.setState({
				value: this.getOption(nextProps.value),
				pk: nextProps.value
			});
		}
	}



	getOption(value) {
		for (var i = 0; i < this.state.options.length; i++) {
			if (this.state.options[i].pk == value)
				return this.state.options[i];
		}
	}

	onChange(value) {
		var pk = (value ? value.pk : '');
		this.setState({
			value: value,
			pk: pk,
		});
		if (this.props.onChange) this.props.onChange(value);
	}


	render() {
		return (
			<div>
				{this.state.pk != null &&
					<Input
						name="tipo"
						value={this.state.pk}
						onChange={(e) => {}}
						className="d-none"
						type="number" disabled={this.props.disabled} />
				}
				<Select
					multi={false}
					value={this.state.value}
					onChange={(value) => this.onChange(value)}
					options={this.state.options}
					disabled={this.props.disabled}
					backspaceRemoves={true}>
				</Select>
			</div>
		);
	}
};

module.exports = UVTTipoSelect;


// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_UVT/UVTTipoSelect.js